import { Box } from '@vp/swan'
import { ReactNode } from 'react'
import { container } from './content-container.module.scss'

export const ContentContainer = ({ children }: { children: ReactNode }) => (
  <Box className={container}>{children}</Box>
)
